import { NuovaAlternativaComponent } from 'app/impostazioni_agenda/alternativa/nuova/nuova';
import { CustomDatepickerI18n } from 'app/model/datepicker';
import { Config } from 'app/config.const';
import { Alternativa } from 'app/model/alternativa';
import { Settimana } from 'app/model/time';
import { NgbDatepickerI18n, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input } from '@angular/core';
import * as moment from 'moment';
import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-calendar';

@Component({
	selector: 'app-alternativa',
	templateUrl: './alternativa.html',
	providers: [{ provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }] // define custom NgbDatepickerI18n provider
})
export class AlternativaComponent {
	@Input() alternativa: Alternativa = null;

	constructor(private calendar: NgbCalendar, private modalService: NgbModal) {
    	// FIXME: Questo sarebbe da mettere in configurazione statica...
		moment.locale(Config.language);
	}

	getEndDate(date: string): moment.Moment {
		return moment(date).add({ days: 6 });
	}

	newAlternativa() {
		const modalRef = this.modalService.open(NuovaAlternativaComponent, {
			keyboard: true,
			backdrop: true,
			size: 'sm'
		});

		modalRef.result.then(
			(week) => this.alternativa.add(week),
			() => {} // Inutile
		);
	}

	delete(settimana: Settimana, $event: MouseEvent) {
		$event.stopPropagation();
		$event.preventDefault();
		this.alternativa.delete(settimana);
	}

	duplica(settimana: Settimana, $event: MouseEvent) {
		$event.stopPropagation();
		$event.preventDefault();
		const oldWeek = moment.utc(settimana.settimana);
		const { result, componentInstance } = this.modalService.open(NuovaAlternativaComponent, {
			keyboard: true,
			backdrop: true,
			size: 'sm'
		});

		componentInstance.tag = settimana.tag;
		componentInstance.isCopying = true;

		componentInstance.setWeek({
			year: oldWeek.year(),
			month: oldWeek.month() - 1,
			day: oldWeek.date()
		});

		result.then(
			(week) => this.alternativa.put(settimana.settimana, week.settimana, week.tag),
			() => {} // Inutile
		);

		return false;
	}
}



// WEBPACK FOOTER //
// ./src/app/impostazioni_agenda/alternativa/alternativa.ts